<template>
  <el-popover
    v-model="popoverVisible"
    :placement="placement"
    trigger="click">
    <div>
      <el-input
        size="small"
        placeholder="输入关键字进行过滤"
        v-model="filterText">
      </el-input>
      <el-tree
        class="filter-tree"
        :data="copyData"
        node-key="value"
        :show-checkbox="true"
        :props="defaultProps"
        @check-change="handleTreeChange"
        :filter-node-method="filterNode"
        ref="tree">
      </el-tree>
      <div>
        <span>{{ isApproval ? "审批人/处理人(最多10人)" : "抄送人(最多5人)" }}</span>
        <div class="approval-process-add-box">
          <!-- <span v-if="isApproval">{{ currentPersonData.title }}</span> -->
          <div class="g-column">
            <span v-for="item in currentPersonData" :key="item.value">
              {{ item.title }}
            </span>
          </div>
          <div class="approval-process-add-box-footer">
            <el-button class="g-plain-confirm-btn" size="mini" plain @click="handleAddApproval">创建</el-button>
            <el-button size="mini" plain @click="handleClose">取消</el-button>
          </div>
        </div>
      </div>
    </div>
    <div slot="reference">
      <slot name="options"></slot>
    </div>
  </el-popover>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import _ from 'lodash';
export default {
  name: 'approvalTree',

  components:{},

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },

  data () {
    return {
			copyData: [],
      popoverVisible: false,
      currentPersonData: {
        title: ""
      },
      filterText: ""
    }
  },

  props: {
		index: {
			type: Number,
			default: 0
		},
		ii: {
			type: Number,
			default: 0
		},
    placement: {
      require: true,
      type: String
    },
    isApproval: {
      require: true,
      type: Boolean
    },
    data: {
      require: true,
      type: Array,
      default: () => []
    },
    defaultProps: {
      require: true,
      type: Object,
    }
	},

  methods: {
    handleClose() {
      this.popoverVisible = false;
    },
    handleAddApproval() {
      if(this.currentPersonData.title || this.getCopyTreeIdArr().length) {
        this.$emit('add-approval', {
					isApproval: this.isApproval ? true : false,
					// id: this.isApproval ? this.currentPersonData : this.getCopyTreeIdArr(),
					id: this.getCopyTreeIdArr(),
          cb: () => {
            this.popoverVisible = false;
						this.currentPersonData = "";
          }
        });
      }else {
        this.$message.warning('请选择节点');
      }
    },
    getCopyTreeIdArr() {
      let arr = this.$refs.tree.getCheckedKeys().filter((item) => {
        return item != undefined;
      })
      return arr;
    },
    handleTreeChange(data, isSelect, node) {
			let arr = this.getCopyTreeIdArr();
      if(!this.isApproval && arr.length > 5) {
        this.$message.warning('抄送人不超过5人');
        this.$refs.tree.setCheckedKeys(arr.slice(0, 5), true);
			}
			if(this.isApproval && arr.length > 10) {
        this.$message.warning('审批/处理人不超过10人');
        this.$refs.tree.setCheckedKeys(arr.slice(0, 10), true);
      }
      const res = this.$refs.tree.getCheckedNodes().filter((item) => {
        return item.type != 'dept';
      })
      this.currentPersonData = res;
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
		},
		getNeedDisableKeys(index, ii) {
			const res = [];
			const singleList = this.getApprovalTempletList[index];
			singleList.forEach((item, i) => {
				if(item.approvaluseid && (i !== ii || ii === singleList.length)) {
					const keys = item.approvaluseid.split(',');
					res.push(...keys)
				}
			})
			return res;
		},
		setDiabledKeys(index, ii) {
			const needDisableKeys = this.getNeedDisableKeys(index, ii);
			function loop(data) {
				data.forEach(item => {
					if(item.children) {
						loop(item.children)
					}else {
						if(needDisableKeys.includes(String(item.value))) {
							item.disabled = true;
						}
					}
				})
			}

			const data = _.cloneDeep(this.getActivityPerson);
			loop(data);
			this.copyData = data;
			console.log(this.copyData);
		},
		setSelectKeys(index, ii) {
			const singleList = this.getApprovalTempletList[index];
			if(ii === singleList.length) {
				return;
			}else {
				const item = singleList[ii];
				if(item && item.approvaluseid) {
					const selectKeys = item.approvaluseid.split(',');
					this.$refs.tree.setCheckedKeys(selectKeys, true);
					this.setCurrentPersonData(selectKeys);
				}
			}
		},
		setCurrentPersonData(selectKeys) {
			const res = [];
			function loop(data) {
				data.forEach(item => {
					if(item.children) {
						loop(item.children)
					}else {
						if(selectKeys.includes(String(item.value))) {
							res.push(item)
						}
					}
				})
			}
			loop(this.copyData);
			this.currentPersonData = res;
		},
		refleshSelectAndDisableData() {
			if(this.isApproval) {
				this.setDiabledKeys(this.index, this.ii);
				this.setSelectKeys(this.index, this.ii);
			}else {
				this.copyData = this.getActivityPerson;
			}
		}
  },

  computed: {
		...mapGetters([
			'getActivityPerson',
			'getApprovalTempletList'
		]),
	},

  created() {},

  mounted() {
		this.refleshSelectAndDisableData();
	},
}
</script>


<style lang='scss'>
.g-column {
  display: flex;
  flex-direction: column;
}

.approval-process-add-box {
  position: relative;
  box-sizing: border-box;
  padding: 10px;
  text-align: center;
  width: 100%;
  min-height: 250px;
  border: 1px solid rgb(199, 199, 199);

  .approval-process-add-box-footer {
    position: absolute;
    bottom: 5px;
    right: 5px;
  }
}

.g-plain-confirm-btn {
  border-color: #1C9EFB !important;
  color: #1C9EFB;
}
</style>
